<template>
  <div>
    <!--test comment-->
    <rare-header-image
    :headerContents="headerContents"
    :headerBackground="'home'"
    />

    <rare-awards :display-bottom-border="true" />

    <rare-home-products-crs />

    <rare-home-products-hemisphere />

    <rare-home-products-candid-ats />

    <rare-home-products-vantage />

    <rare-home-products-attraction-development />

    <rare-clients-logos/>

  </div>
</template>

<script>
import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareAwards from '../../components/carousels/awardsCarousel';

import RareHomeHeaderContents from './components/RareHomeHeaderContents';
import RareHomeProductsAttractionDevelopment from './components/RareHomeProductsAttractionDevelopment';
import RareClientsLogos from './components/RareHomeClientsLogos';

import RareHomeProductsCRS from './components/RareHomeProductsCRS';
import RareHomeProductsCandidAts from './components/RareHomeProductsCandidAts';
import RareHomeProductsVantage from './components/RareHomeProductsVantage';
import RareHomeProductsHemisphere from './components/RareHomeProductsHemisphere';

export default {
  name: 'homeProducts',
  components: {
    'rare-header-image': HeaderHeroImage,
    'rare-clients-logos': RareClientsLogos,
    'rare-home-products-header-contents': RareHomeHeaderContents,
    'rare-home-products-attraction-development': RareHomeProductsAttractionDevelopment,
    'rare-awards': RareAwards,
    'rare-home-products-crs': RareHomeProductsCRS,
    'rare-home-products-candid-ats': RareHomeProductsCandidAts,
    'rare-home-products-vantage': RareHomeProductsVantage,
    'rare-home-products-hemisphere': RareHomeProductsHemisphere,
  },
  data() {
    return {
      headerContents: 'rare-home-header-contents',
      researchText: 'Big datasets from our operations and in-depth qualitative insights from our candidates and clients inform our research-led innovations, including the Contextual Recruitment System, <a href="https://www.hemisphereapp.io/" target="blank" style="color: #ffffff; ">Hemisphere</a> and the <a style="color: #ffffff; " href="https://racefairnesscommitment.com/" target="blank">Race Fairness Commitment</a>.',
    };
  },
};

</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";


</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProducts.vue